module.exports = __webpack_public_path__ + "static/ZRN-Logo-RED-FNL-fe61f1bbf5cadd6c40f338241871a653.png";